<app-warehouse-file-upload
  (selectFilesEvent)="handleSelectFilesEvent($event)"
  [allowedMimeTypes]="allowedMimeTypes"
  [disabled]="disabled()"
  [maxFileSize]="maxFileSize"
  [selectedFileIds]="selectedFileIds()" />
